export default function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}


//////////////////
// WEBPACK FOOTER
// /data/websites/gruppolunelli.it/httpdocs/wp-content/themes/g2k-theme/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
// module id = 5
// module chunks = 0